import { createFeatureSelector, createSelector, select } from '@ngrx/store';

import { StateSelector } from '@fcom/core/selectors/selector-utils';

import {
  PNR_WIDGET_FEATURE_KEY,
  PnrWidgetState,
  UpcomingTrip,
  UpcomingTripsFetchStatus,
  UpcomingTripsState,
} from '../../interfaces';

const selectPnrWidgetState = createFeatureSelector<PnrWidgetState>(PNR_WIDGET_FEATURE_KEY);
const selectUpcomingTripsState = createSelector(selectPnrWidgetState, (state: PnrWidgetState) => state.tripsMmb);

const selectUpcomingTrips = createSelector(
  selectUpcomingTripsState,
  (state: UpcomingTripsState) => state.upcomingTrips
);
const selectUpcomingTripsStatus = createSelector(selectUpcomingTripsState, (state: UpcomingTripsState) => state.status);

export const getUpcomingTrips = (): StateSelector<PnrWidgetState, UpcomingTrip[]> => select(selectUpcomingTrips);
export const getUpcomingTripsStatus = (): StateSelector<PnrWidgetState, UpcomingTripsFetchStatus> =>
  select(selectUpcomingTripsStatus);
